/* @flow */

import VanillaToasts from 'vanillatoasts';

import { type $AxiosError } from 'axios';
import { type PhpException } from '../utils/types';

const exibirErroUpload = (erro: $AxiosError<PhpException>, title: string) => {
    if (erro.response) {
        VanillaToasts.create({
            title,
            text: erro.response.data.message,
            type: 'danger',
            timeout: 5000,
        });
    }

    throw erro;
};

export default exibirErroUpload;
